'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colAmount = exports.containerWidths = exports.gutterWidths = exports.colWidths = undefined;
exports.generateColumn = generateColumn;
exports.generateMediaQuery = generateMediaQuery;

var _glamor = require('@headspace/glamor');

var _breakpoints = require('./breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _flex = require('./flex');

var _flex2 = _interopRequireDefault(_flex);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // generates a bunch of col classes and a container classes
// eg. col2xl col1s container


var colWidths = exports.colWidths = {
  xxl: 72,
  xl: 64,
  l: 48,
  m: 32,
  base: 58
};
var gutterWidths = exports.gutterWidths = {
  xxl: 24,
  xl: 24,
  l: 24,
  m: 16,
  base: 8
};
var containerWidths = exports.containerWidths = {
  xxl: 1128,
  xl: 1032,
  l: 840,
  m: 560,
  base: 248
};
var colAmount = exports.colAmount = {
  xxl: 12,
  xl: 12,
  l: 12,
  m: 12,
  base: 4
};

function generateColumn(colWidth, gutterWidth, col, amount) {
  var _ref;

  var width = colWidth * col + gutterWidth * (col - 1);
  return _ref = {
    flex: 0,
    width: width,
    minWidth: width,
    marginRight: gutterWidth
  }, _defineProperty(_ref, ':nth-child(' + amount / col + 'n)', {
    marginRight: 0
  }), _defineProperty(_ref, ':last-child', {
    marginRight: 0
  }), _ref;
}

function generateMediaQuery(breakpoint, lastBreakpoint) {
  var mediaquery = '@media(min-width: ' + _breakpoints2.default[breakpoint] + 'px)';

  if (lastBreakpoint) {
    mediaquery = mediaquery + ' and (max-width: ' + (_breakpoints2.default[lastBreakpoint] - 1) + 'px)';
  }

  return mediaquery;
}

var colArr = Object.keys(colWidths);
var columns = colArr.reverse().reduce(function (accum, breakpoint, i) {
  var amount = colAmount[breakpoint];
  var width = colWidths[breakpoint];
  var gutter = gutterWidths[breakpoint];
  var lastBreakpoint = colArr[i + 1];

  for (var _i = 0; _i <= amount; _i++) {
    if (breakpoint === 'base') {
      return accum;
    } else {
      accum['col' + _i + breakpoint] = (0, _glamor.css)(_defineProperty({}, generateMediaQuery(breakpoint, lastBreakpoint), generateColumn(width, gutter, _i, amount)));
      accum['push' + _i + breakpoint] = (0, _glamor.css)(_defineProperty({}, generateMediaQuery(breakpoint, lastBreakpoint), {
        marginLeft: width * _i + gutter * _i
      }));
    }
  }

  return accum;
}, {
  col1s: (0, _glamor.css)(_defineProperty({}, '@media (max-width: ' + _breakpoints2.default.m + 'px)', {
    flex: 1,
    marginRight: '2%',
    minWidth: '22%',
    width: '22%',
    ':nth-child(4n)': {
      marginRight: 0
    }
  })),
  col2s: (0, _glamor.css)(_defineProperty({}, '@media (max-width: ' + _breakpoints2.default.m + 'px)', {
    flex: 2,
    marginRight: '2%',
    minWidth: '44%',
    width: '44%',
    ':nth-child(2n)': {
      marginRight: 0
    }
  })),
  col4s: (0, _glamor.css)(_defineProperty({}, '@media (max-width: ' + _breakpoints2.default.m + 'px)', {
    flex: 4,
    minWidth: '100%',
    width: '100%',
    marginRight: 0
  }))
});
columns.container = (0, _glamor.css)(_flex2.default.flex, _flex2.default.row, Object.keys(containerWidths).reverse().reduce(function (accum, breakpoint) {
  var width = containerWidths[breakpoint];

  if (breakpoint === 'base') {
    accum.width = '80%';
  } else {
    accum['@media(min-width: ' + _breakpoints2.default[breakpoint] + 'px)'] = {
      width: width,
      marginLeft: 'auto',
      marginRight: 'auto'
    };
  }

  return accum;
}, {
  marginLeft: 'auto',
  marginRight: 'auto'
}));
exports.default = columns;